<template>
  <v-container fluid class="px-0">
    <v-layout class="dark--text mt-6 ms-3 mb-4">
      <h3>Brand</h3>

      <v-spacer></v-spacer>
      <BrandForm />
    </v-layout>
    <!-- {{ faqList }} -->
    <BrandTable :brandList="brandList" :loading="loading"></BrandTable>
  </v-container>
</template>

<script>
import BrandForm from "../components/BrandForm.vue";
import BrandTable from "../components/BrandTable.vue";

export default {
  components: {
    BrandTable,
    BrandForm,
  },
  methods: {},
  data: () => ({
    loading: true,
    brandList: [],
    totalItemsCount: 25,
    variables: {
      limit: 25,
      skip: 0,
    },
  }),
  apollo: {
    listAllBrands() {
      // console.log("djfd");
      return {
        query: require("@/stock/brand/api/listAllBrands.graphql"),

        result({ data, loading }) {
          this.loading = loading;
          this.brandList = data.listAllBrands;
        },
      };
    },
  },
};
</script>
